import { render, staticRenderFns } from "./OmxSkeleton.vue?vue&type=template&id=2f371c14&scoped=true"
import script from "./OmxSkeleton.vue?vue&type=script&lang=js"
export * from "./OmxSkeleton.vue?vue&type=script&lang=js"
import style0 from "./OmxSkeleton.vue?vue&type=style&index=0&id=2f371c14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f371c14",
  null
  
)

export default component.exports